const body = document.body;
const input = document.querySelector('#mobile-menu')

function init() {
    if (!input) return

    input.addEventListener('change', () => {
        const method = input.checked ? 'add' : 'remove'
        body.classList[method]('mobile-menu--active')
    })
}

init()
